// extracted by mini-css-extract-plugin
export default {"menuSelector":"profile-menu-module__menuSelector___iv6yq","chevron":"profile-menu-module__chevron___UrSkm","avatar":"profile-menu-module__avatar____n2h1"};